import React from 'react';
import CenteredFullHeightContainer from '../containers/CenteredFullHeightContainer';
import BrandLoader from './BrandLoader';

const FullPageCircularProgress = ({ message, size = 120 }) => {
    return (
        <CenteredFullHeightContainer>
            <BrandLoader size={size} message={message} />
        </CenteredFullHeightContainer>
    );
};

export default FullPageCircularProgress;